import imageCompression from 'browser-image-compression';
import Cropper from 'cropperjs';

export const httpRequest = async (method, url, body = {}) => {
    let you = localStorage.getItem('you');
    const socketId = localStorage.getItem('socketId');
    if (you) you = JSON.parse(you);

    const responseOptions = {
        method,
        headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Authorization": `Bearer ${socketId};${you?.id}`,
            "Token": process.env.VUE_APP_API_KEY,
            "Cache-Control": "no-cache"
        }
    };
    if (method.toLowerCase() !== 'get') responseOptions.body = JSON.stringify(body);

    const response = await fetch(process.env.VUE_APP_API_URL + url, responseOptions);
    if (!response.ok) return 'failed';

    if (url.endsWith('/avatar')) addResponseToCache(url, response.clone());

    let result = await response.json();
    try {
        result = JSON.parse(result);
    } catch(error) {}

    return result;
}

export const uploadAvatar = async (id, file) => {
    const { blob } = await cropImageToSquare(file);

    const options = {
        maxWidthOrHeight: 400,
        useWebWorker: true,
        fileType: 'image/webp',
        initialQuality: 1,
    };

    const compressedFile = await new Promise((resolve, reject) =>  {
        imageCompression(blob, options)
            .then(compressedFile => {
                resolve(compressedFile)
            })
            .catch(error => {
                console.log(error)
                reject(null)
            })
    });

    const base64 = await toBase64(compressedFile);
    const url = `/users/${id}/avatar_updated`;
    const body = {
        avatar: base64
    };

    const result = await httpRequest('POST', url, body);
    if(result === 'failed') return
    
    return base64
}

// export function base64ToBlob(base64) {
//     const byteString = atob(base64.split(',')[1]);
//     const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
  
//     const ab = new ArrayBuffer(byteString.length);
//     const ia = new Uint8Array(ab);
//     for (let i = 0; i < byteString.length; i++) {
//       ia[i] = byteString.charCodeAt(i);
//     }
  
//     return new Blob([ab], { type: mimeString });
// }

export async function toBase64(file) {
    return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    })
}

async function addResponseToCache(url, response) {
    const userId = url.split('/')[2];

    // cache the new avatar
    const cache = await caches.open('profile-images');
    await cache.put(`${process.env.VUE_APP_API_URL}/users/${userId}/avatar`, response);
}

export async function cropImageToSquare(file, size = 400) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const minSide = Math.min(img.width, img.height);
          const startX = (img.width - minSide) / 2;
          const startY = (img.height - minSide) / 2;
  
          // Canvas maken (vierkant)
          const canvas = document.createElement("canvas");
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext("2d");
  
          // Croppen + resizen in één stap
          ctx.drawImage(
            img,
            startX, startY,     // waar crop begint
            minSide, minSide,   // grootte van crop
            0, 0,               // waar tekenen op canvas
            size, size          // output resolutie (400x400)
          );
  
          // Canvas → Blob → klaar
          canvas.toBlob(
            blob => resolve({ blob, canvas }),
            "image/png",
            1
          );
        };
  
        img.onerror = reject;
        img.src = reader.result;
      };
  
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }